import { useMutation } from '@tanstack/react-query';
import { updateUser, UserFields } from 'shared/services/backend-api';

export const useUpdateUserMutation = () =>
  useMutation({
    mutationFn: (userFields: Partial<UserFields>) => updateUser(userFields),
  });
